import { FolkArrow } from '../folk-arrow';
FolkArrow.define();
export { FolkArrow };
//# sourceMappingURL=folk-arrow.js.map